var _defs, _g, _g2, _g3, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon14(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "e24ef02f79"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18.964844 18.964844 L 356.035156 18.964844 L 356.035156 356.035156 L 18.964844 356.035156 Z M 18.964844 18.964844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7bebc364ec"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 18.964844 C 94.421875 18.964844 18.964844 94.421875 18.964844 187.5 C 18.964844 280.578125 94.421875 356.035156 187.5 356.035156 C 280.578125 356.035156 356.035156 280.578125 356.035156 187.5 C 356.035156 94.421875 280.578125 18.964844 187.5 18.964844 Z M 187.5 18.964844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9cf0bd3375"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.964844 0.964844 L 338.035156 0.964844 L 338.035156 338.035156 L 0.964844 338.035156 Z M 0.964844 0.964844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ca7538e638"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 169.5 0.964844 C 76.421875 0.964844 0.964844 76.421875 0.964844 169.5 C 0.964844 262.578125 76.421875 338.035156 169.5 338.035156 C 262.578125 338.035156 338.035156 262.578125 338.035156 169.5 C 338.035156 76.421875 262.578125 0.964844 169.5 0.964844 Z M 169.5 0.964844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ae98a84fb0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 339,
    y: 0,
    height: 339
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "33c56ccf38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 77 99.496094 L 298 99.496094 L 298 275.746094 L 77 275.746094 Z M 77 99.496094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7f9dc52ee7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 101.425781 122.5 C 101.011719 110.53125 110.335938 99.496094 122.9375 99.496094 L 252.070312 99.496094 C 264.675781 99.496094 273.996094 110.53125 273.582031 122.5 C 273.179688 133.992188 273.699219 148.882812 277.449219 161.023438 C 281.207031 173.203125 287.546875 180.902344 297.929688 181.890625 L 297.929688 193.105469 C 287.546875 194.097656 281.207031 201.792969 277.449219 213.972656 C 273.699219 226.113281 273.179688 241.003906 273.582031 252.5 C 273.996094 264.464844 264.675781 275.5 252.070312 275.5 L 122.9375 275.5 C 110.335938 275.5 101.011719 264.464844 101.429688 252.5 C 101.828125 241.003906 101.308594 226.113281 97.558594 213.972656 C 93.800781 201.792969 87.445312 194.097656 77.0625 193.105469 L 77.0625 181.890625 C 87.445312 180.902344 93.800781 173.203125 97.558594 161.023438 C 101.308594 148.882812 101.828125 133.992188 101.425781 122.5 Z M 101.425781 122.5 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b56ef43f37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 153 140 L 225 140 L 225 235 L 153 235 Z M 153 140 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9b71404b42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 192.285156 234.285156 C 212.6875 234.285156 224.984375 224.296875 224.984375 207.816406 C 224.984375 195.363281 216.210938 186.347656 203.183594 184.917969 L 203.183594 184.398438 C 212.753906 182.84375 220.265625 173.957031 220.265625 164.03125 C 220.265625 149.886719 209.101562 140.675781 192.085938 140.675781 L 153.804688 140.675781 L 153.804688 234.285156 Z M 168.691406 152.546875 L 188.496094 152.546875 C 199.265625 152.546875 205.378906 157.347656 205.378906 166.039062 C 205.378906 175.316406 198.265625 180.507812 185.375 180.507812 L 168.691406 180.507812 Z M 168.691406 222.414062 L 168.691406 191.601562 L 188.363281 191.601562 C 202.453125 191.601562 209.765625 196.789062 209.765625 206.910156 C 209.765625 217.03125 202.652344 222.414062 189.230469 222.414062 Z M 168.691406 222.414062 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e24ef02f79)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7bebc364ec)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 18, 18)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ae98a84fb0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9cf0bd3375)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ca7538e638)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9013fe",
    d: "M 0.964844 0.964844 L 338.035156 0.964844 L 338.035156 338.035156 L 0.964844 338.035156 Z M 0.964844 0.964844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#33c56ccf38)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7f9dc52ee7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 77.0625 99.496094 L 77.0625 275.5 L 297.929688 275.5 L 297.929688 99.496094 Z M 77.0625 99.496094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b56ef43f37)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9b71404b42)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9013fe",
    d: "M 153.804688 140.675781 L 153.804688 234.285156 L 224.984375 234.285156 L 224.984375 140.675781 Z M 153.804688 140.675781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.431382, 0, 0, 0.431382, 77.062535, 99.497353)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 267.101076 312.455724 C 314.396372 312.455724 342.902133 289.301584 342.902133 251.097706 C 342.902133 222.229737 322.56416 201.330341 292.365077 198.016139 L 292.365077 196.811797 C 314.55031 193.207829 331.963455 172.607255 331.963455 149.597998 C 331.963455 116.809128 306.083701 95.456973 266.639261 95.456973 L 177.898326 95.456973 L 177.898326 312.455724 Z M 212.407684 122.975718 L 258.317534 122.975718 C 283.282714 122.975718 297.454098 134.104555 297.454098 154.25237 C 297.454098 175.758463 280.964583 187.792821 251.082432 187.792821 L 212.407684 187.792821 Z M 212.407684 284.936979 L 212.407684 213.509581 L 258.009658 213.509581 C 290.671755 213.509581 307.623084 225.534884 307.623084 248.9969 C 307.623084 272.458917 291.13357 284.936979 260.019912 284.936979 Z M 212.407684 284.936979 ",
    stroke: "#ffffff",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon14);
export default __webpack_public_path__ + "static/media/icon14.537df684cd9096359fd6136fd4d15567.svg";
export { ForwardRef as ReactComponent };